import { isEmpty, isEqual } from 'lodash'
import { FormErrors } from 'redux-form'
import i18n from '../../../i18n'
import { IChangePasswordValues } from './withReduxForm'

export default function({
  oldPassword,
  newPassword,
  newPasswordAgain,
}: IChangePasswordValues): FormErrors<IChangePasswordValues, string> {
  const errors: FormErrors<IChangePasswordValues, string> = {}

  if (oldPassword !== undefined) {
    if (isEmpty(oldPassword)) {
      errors.oldPassword = i18n.t('reg_error_password_empty')
    }
  }
  if (newPassword !== undefined) {
    if (isEmpty(newPassword)) {
      errors.newPassword = i18n.t('reg_error_password_empty')
    }
    if (!isEmpty(newPassword) && newPassword.includes(' ')) {
      errors.newPassword = i18n.t('reg_error_password_contains_space')
    }
    if (!isEmpty(newPassword) && newPassword.length < 6) {
      errors.newPassword = i18n.t('BBO_936_password_to_short')
    }
  }
  if (newPasswordAgain !== undefined) {
    if (isEmpty(newPasswordAgain)) {
      errors.newPasswordAgain = i18n.t('reg_error_password_conf_empty')
    }
    if (!isEmpty(newPasswordAgain) && !isEqual(newPassword, newPasswordAgain)) {
      errors.newPasswordAgain = i18n.t('reg_error_password_and_conf_not_match')
    }
  } else if (
    isEmpty(newPasswordAgain) &&
    (!isEmpty(newPassword) && newPassword.length >= 6)
  ) {
    errors.newPasswordAgain = i18n.t('reg_error_password_conf_empty')
  }
  return errors
}
